import React from 'react';
import Spin from 'src/components/common/Spin';
import styles from './Loading.module.less';

type LoadingProps = {
  isVisible: boolean;
};

const Loading: React.FC<LoadingProps> = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Spin spinning={isVisible} />
    </div>
  );
};

export default Loading;
